<span class="mo-selector-option-container" [class]="containerClass">
  <tc-master-operator-connect-indicator
    *ngIf="!hideConnect"
    [instance]="instance"
    [snapshot]="snapshot"
    [scenario]="scenario"
  ></tc-master-operator-connect-indicator>
  <span class="scenario-pill">{{ scenario?.name }}</span>
  <tc-mo-connect-form-simulation-option
    [hideConnect]="true"
    [instance]="instance"
    [snapshot]="snapshot"
    [containerClass]="containerClass"
  ></tc-mo-connect-form-simulation-option>
</span>
